import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=11c09728&scoped=true"
import script from "./EditContact.vue?vue&type=script&lang=js"
export * from "./EditContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c09728",
  null
  
)

export default component.exports